import {
  createMemoryHistory,
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from 'vue-router'
import routes, { Page } from './routes'
import { useAuthStore } from 'stores/auth'
import { Notify } from 'quasar'
import { i18n } from 'boot/i18n'

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

const createHistory = process.env.SERVER
  ? createMemoryHistory
  : process.env.VUE_ROUTER_MODE === 'history'
    ? createWebHistory
    : createWebHashHistory

const Router = createRouter({
  scrollBehavior: () => ({ left: 0, top: 0 }),
  routes,

  // Leave this as is and make changes in quasar.conf.js instead!
  // quasar.conf.js -> build -> vueRouterMode
  // quasar.conf.js -> build -> publicPath
  history: createHistory(process.env.VUE_ROUTER_BASE),
})

Router.beforeEach((to, from, next) => {
  const store = useAuthStore()
  if (
    store.isAuthenticated &&
    [/^\/app(\/)?$/, /^\/app\/signin$/].some((path) => to.fullPath.match(path))
  ) {
    return next({ name: Page.Trips })
  }

  if (!store.isAuthenticated && !to.meta.isPublic) {
    const authStore = useAuthStore()
    authStore.setAfterSignInRedirection(to.fullPath)
    if (authStore.hasRefreshTokenExpired()) {
      Notify.create({
        message: i18n.global.t('general.error.refreshTokenExpired'),
        color: 'white',
        textColor: 'dark',
        icon: 'fa-regular fa-user-shield',
        timeout: 3000,
        iconSize: 'lg',
        iconColor: 'dark',
      })
    }
    void authStore.signOut()

    return
  }

  return next()
})

export default Router
